<template>
  <div id="serp-container" class="bg-white pt-5">
    <div v-if="loading">
      <div class="flex flex-wrap justify-center max-w-5xl mx-auto">
        <div class="card w-80" v-for="i in [1,2,3,4,5,6]">
          <div class="card bg-base-100 image-full  shadow-xl m-3">
            <div class="skeleton w-full" style="height: 166px"></div>
          </div>
          <div class="card-body p-3">
            <div class="skeleton h-4 w-28"></div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="max-w-5xl mx-auto">
      <div v-if="selectedCategory.description" class="px-5">
        <h1 class="text-2xl pb-8 font-thin">
          {{selectedCategory.description}}
        </h1>
      </div>
      <div class="flex flex-wrap justify-center" v-if="results">
        <ui-onp-card :record="record" v-for="record in results" @record:open="openRecord"/>
      </div>
      <div v-else class="container mx-auto text-center p-5">
        <h1>Non abbiamo trovato nessun ente!</h1>
      </div>
    </div>


    <template-disclaimer/>
  </div>
  <ui-modal ref="dialog" @dismiss="isOpen = false" class="p-0">
    <template #body>
      <NuxtPage/>
    </template>
  </ui-modal>

</template>

<script setup lang="ts">
import type {ONPRecord} from "~/types/record";

const props = defineProps(['path', 'filterCategory', 'results', 'loading','selectedCategory']);
const dialog = ref(null);
const path = ref(props.path);
const {$listen} = useNuxtApp();
const {params} = useRoute();
const isOpen = ref(false);

const openRecord = async (record: ONPRecord) => {
  isOpen.value = true;
  setTimeout(() => {
    dialog.value?.setOpen(true);
  }, 100);
  await navigateTo({path: `/${path.value}/${params.slug}/record-${record.id}`})
}


onMounted(async () => {
  // Se è presente un id nella route apro il record
  if (params.id) {
    await openRecord({id: params.id});
  }
  // Listener per aprire il record
  $listen('record:detail', async (record: ONPRecord) => {
    await openRecord(record);
  });
})
</script>

<style>

</style>